import { render, staticRenderFns } from "./RegisteredProducts.vue?vue&type=template&id=0b2b80ef"
import script from "./RegisteredProducts.vue?vue&type=script&lang=js"
export * from "./RegisteredProducts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports